<script>
import time from '../../utils/time';
export default {
  props: {
    color: {
      type: String,
      default: ''
    },
    videoDuration: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      duration: ''
    }
  },
  created() {
   this.renderDuration(this.videoDuration)
  },
  methods: {
    renderDuration(videoDuration) {
      if (videoDuration) {
          const duration = time.secondsToHms(videoDuration);
          this.duration = duration;
      }
      else {
        this.duration = '--:--'
      }
    }
  }
}
</script>
<template>
  <span class="text-primary video-time t-xs" :class="color && 'bg-' + color">{{duration}}</span>
</template>
